import state from 'shared/helpers/vuex/state'

export default {
    ...state
}


// WEBPACK FOOTER //
// ./src/enterprise/vuex/state.js